import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from "angular-google-tag-manager";
import { Booking } from "@modules/booking/models/booking";
import { GoogleAnalyticsEcommerce, GoogleAnalyticsEcommerceItem } from "@core/models/google-analytics-ecommerce";
import { coerceNumberProperty } from "@angular/cdk/coercion";

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor(private gtmService: GoogleTagManagerService) {
  }

  addBookingPurchaseToAnalytics(booking: Booking, paymentIntent: any, participants: number): void {
    this.gtmService.pushTag({
      ...this.transformBookingToGoogleAnalyticPayload(booking, paymentIntent, participants)
    });
  }

  private transformBookingToGoogleAnalyticPayload(
    {
      price: {currency, pricePerPerson: price},
      serviceRef: {title: item_name, id: item_id, bookingType: item_category}
    }: Booking,
    paymentIntent: any, quantity: number
  ): GoogleAnalyticsEcommerce {
    return {
      event: 'purchase',
      ecommerce: {
        currency: currency,
        value: this.calculateTotalPaymentAmount(paymentIntent.payIn, quantity),
        transaction_id: paymentIntent.transactionRef,
        items: [
          {
            item_name,
            item_id,
            price,
            item_category,
            quantity
          }
        ]
      }
    }
  }

  private calculateTotalPaymentAmount(payIn: number, quantity: number): number {
    return coerceNumberProperty((payIn * quantity).toFixed(2));
  }
}
